import Vue from 'vue'
import Meta from 'vue-meta'
import VueRouter from 'vue-router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 加载路由
Vue.use(VueRouter)
// 使用MATA管理 
Vue.use(Meta)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/view/Home.vue'),
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('@/view/Order.vue'),
    },
    {
      path: '/excel',
      name: 'Excel',
      component: () => import('@/view/Excel.vue'),
    }
  ]
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 进度条
  NProgress.start()

  // 未登陆
  if(!store.getters.isLogin) {
    try {
      // 检测登陆
      await store.dispatch('user')
    } catch (error) {
      // 重定向首页
      location.href = '/#login'
      return next(false)
    }
  }
  
  next()
})

router.afterEach(() => {
	NProgress.done()
})

export default router